<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="section border-t border-chsc-indigo-500">
        <UiContainer>
            <header class="mb-20 global-text text-center">
                <StoryblokRichText :doc="blok?.header" />
            </header>
        </UiContainer>
        <div class="relative">
            <img
                :src="blok?.map.filename"
                :alt="blok?.map.alt"
                class="w-full"
            >
        </div>
    </section>
</template>
